import {Component, forwardRef, Input, Output, EventEmitter, ChangeDetectorRef, NgZone} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ModalService} from '@vendure/admin-ui/core';
import {AssetPickerDialogComponent} from '../dialog/asset-picker-dialog/asset-picker-dialog.component';
import {cloneDeep} from 'lodash';
// import {} from '@vendure/core';

@Component({
  selector: 'image-picker',
  templateUrl: './image-picker.component.html',
  styleUrls: ['./image-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImagePickerComponent),
      multi: true,
    },
  ],
})
export class ImagePickerComponent implements ControlValueAccessor {
  @Input() multiple = false;
  @Input() showRemove = true;
  @Input() width: string;
  @Input() height: string;
  @Output() select = new EventEmitter();
  // @Input() value: string[] = [];
  previewImages: string[] = [];
  onChange = (imgs: string[] | string) => {};
  onTouchedCallback: () => void;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private modalService: ModalService,
    private ngZone: NgZone,
  ) {}

  registerOnChange(fn: (value: string | Array<string>) => void) {
    this.onChange = () => {
      // this.ngZone.run(() => {
      if (this.multiple) {
        fn(this.previewImages);
      } else {
        fn(this.previewImages[0]);
      }
      this.changeDetectorRef.detectChanges();
      // });
    };
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchedCallback = fn;
  }

  writeValue(value: string[] | string) {
    if (!value) return;
    console.log('writeValue', value);
    if (this.multiple) {
      this.previewImages = cloneDeep(value) as string[];
    } else {
      if (Array.isArray(value)) {
        this.previewImages = value;
      } else {
        this.previewImages = [value as string];
      }
    }
    // this.onChange(this.previewImages);
    console.log(this.previewImages);
    this.changeDetectorRef.detectChanges();
  }

  selectAssets(index = -1) {
    const change = index > -1;
    this.onTouchedCallback();
    this.modalService
      .fromComponent(AssetPickerDialogComponent, {
        locals: {
          multiSelect: change ? false : this.multiple,
        },

        size: 'xl',

        // multiSelect: true,
      })
      .subscribe(result => {
        if (result?.length) {
          // ...
          // console.log(result);
          // const item = result[0];

          if (change) {
            this.previewImages[index] = result[0].source;
          } else {
            this.previewImages = [...this.previewImages, ...result.map(item => item.source)];
          }
          this.onChange(this.previewImages);
          setTimeout(() => {
            this.select.emit(this.previewImages);
          });
          // this.changeDetectorRef.detectChanges();
        }
      });
  }

  remove(index: number, e: Event) {
    e.stopPropagation();
    // console.log(this.previewImages);
    this.previewImages.splice(index, 1);
    this.onChange(this.multiple ? this.previewImages : this.previewImages?.[0] || '');
    setTimeout(() => {
      this.select.emit(this.previewImages);
    });
  }

  // handleDragStart(e: Event) {
  //   console.log(e);
  // }
  // handleDragEnter(e: Event) {
  //   console.log(e);
  // }
  handleDrag(e: CdkDragDrop<number>) {
    moveItemInArray(this.previewImages, e.previousContainer.data, e.container.data);
    this.onChange(this.previewImages);
  }
  // handleDragEnd(e: Event) {
  //   console.log(e);
  // }
}
